<script setup lang="ts">
import { ColorOption } from "@/models/frontend-only/ColorOption";

const value = defineModel<string>();
const dark = useDarkModeStore();

defineProps<{
  options: ColorOption[];
  highlight?: boolean;
}>();
</script>

<template>
  <div class="color-select grid grid-cols-4 gap-1">
    <button
      v-for="o of options"
      :key="o.name"
      type="button"
      :class="{ active: value === o.name }"
      :data-sheet-font-color="!highlight ? o.name : undefined"
      :data-sheet-highlight-color="highlight ? o.name : undefined"
      @click="value = o.name"
    >
      <div
        v-if="o.name !== 'transparent'"
        :style="{
          'background-color': dark.isDarkModeEnabled ? o.dark : o.light,
        }"
        class="color-square"
      ></div>
      <FAIcon
        v-else
        class="fa-light fa-xmark transparent-square fa-2x flex items-center justify-center"
      />
    </button>
  </div>
</template>

<style scoped lang="postcss">
.color-square {
  @apply h-7 w-7 rounded;
}
button {
  @apply btn btn-square btn-sm h-11 w-11 bg-white p-1 transition-all hover:brightness-90;
}
.dark .button {
  @aply bg-black;
}
button.active {
  @apply bg-white outline outline-gray-300;
}
.transparent-square {
  @apply h-8 w-8 w-full rounded bg-white text-error;
}
.dark .transparent-square {
  @apply bg-black text-red-400;
}
</style>
